import styled from 'styled-components';
import { ColStyled } from '../ColStyled';

export const ColStyledAP = styled(ColStyled)``;
